import { createAction } from '@reduxjs/toolkit';
import {
  GET_USER,
  GET_USER_FAIL,
  GET_USER_SUCCESS,
  SET_IS_NOTIFIED,
  SIGN_UP,
  SIGN_UP_FAIL,
  SIGN_UP_SUCCESS,
  User,
  UserFormData,
} from './appModel';

export const setIsNotified = createAction(
  SET_IS_NOTIFIED,
  (isNotified: boolean) => ({
    payload: { isNotified },
  })
);

export const getUser = createAction(GET_USER);
export const getUserSuccess = createAction(GET_USER_SUCCESS, (user: User) => ({
  payload: { user },
}));
export const getUserFail = createAction(GET_USER_FAIL);

export const signUp = createAction(
  SIGN_UP,
  (formData: UserFormData, onConfirm: () => void) => ({
    payload: { formData, onConfirm },
  })
);
export const signUpSuccess = createAction(SIGN_UP_SUCCESS);
export const signUpFail = createAction(SIGN_UP_FAIL);
